/**
 * Error vuex module is the popup that slides from the bottom of the screen
 * and displays some information. Some form of snackbar
 */

// 5 seconds is the time that this snackbar will last
const DEFAULT_TIMEOUT = 5000;
let timer;

export const state = () => ({
  value: null,
});

export const mutations = {
  changeValue(state, value) {
    state.value = value;
  },
};

export const actions = {
  create({ commit, dispatch }, value) {
    commit('changeValue', value);
    timer = setTimeout(() => {
      dispatch('remove');
    }, DEFAULT_TIMEOUT);
  },

  remove({ commit }) {
    commit('changeValue', null);
    clearTimeout(timer);
  },
};

export default { namespaced: true, state, mutations, actions };
